import { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { Button } from "../components/common/Button";
import { Input } from "../components/common/Input";
import { changePassword, me } from "../api/auth";
import { useAuthStore } from "../store/authStore";
import { clearClientSession } from "../store/session";
import { formatApiError } from "../lib/apiError";

export default function ChangePasswordPage() {
  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass2, setNewPass2] = useState("");
  const [loading, setLoading] = useState(false);

  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: { pathname?: string } } };

  useEffect(() => {
    if (user) return;
    me().then(setUser).catch(() => {});
  }, [user, setUser]);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (newPass !== newPass2) {
      toast.error("Las contrasenas no coinciden");
      return;
    }
    if (newPass.length < 8) {
      toast.error("Minimo 8 caracteres");
      return;
    }
    setLoading(true);
    try {
      await changePassword(currentPass, newPass);
      toast.success("Contrasena actualizada");
      const freshUser = await me();
      setUser(freshUser);
      const dst = loc.state?.from?.pathname || "/live";
      nav(dst === "/change-password" ? "/live" : dst, { replace: true });
    } catch (e) {
      toast.error(formatApiError(e, "No se pudo cambiar la contrasena"));
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    clearClientSession();
    nav("/login", { replace: true });
  };

  return (
    <div className="flex items-center justify-center h-screen bg-bg">
      <form
        onSubmit={submit}
        className="bg-panel border border-line rounded shadow-2xl p-6 w-full max-w-sm space-y-4"
      >
        <h1 className="text-lg font-semibold">Cambiar contrasena</h1>
        <p className="text-xs text-muted">
          Antes de continuar debes definir una contrasena nueva.
        </p>
        <Input
          label="Contrasena actual"
          type="password"
          value={currentPass}
          onChange={(e) => setCurrentPass(e.target.value)}
          autoFocus
          required
          autoComplete="current-password"
          disabled={loading}
        />
        <Input
          label="Nueva contrasena"
          type="password"
          value={newPass}
          onChange={(e) => setNewPass(e.target.value)}
          required
          autoComplete="new-password"
          disabled={loading}
        />
        <Input
          label="Repetir contrasena"
          type="password"
          value={newPass2}
          onChange={(e) => setNewPass2(e.target.value)}
          required
          autoComplete="new-password"
          disabled={loading}
        />
        <Button type="submit" variant="primary" loading={loading} className="w-full">
          Guardar
        </Button>
        <Button type="button" variant="ghost" disabled={loading} className="w-full" onClick={logout}>
          Salir
        </Button>
      </form>
    </div>
  );
}
